// 小徽章：状态（web 自己的色调映射）、优先级、成熟度、dry run；进度条
import type { Maturity, Priority, TaskStatus } from "@csp/shared";
import { MATURITY_TEXT, PRIORITY_TEXT } from "../lib/format";
import { MARKER_TONE, PRIORITY_TONE, STATUS_TONE, statusLabel, toneClass, type Tone } from "../lib/statusTone";
import { MARKER_TEXT } from "./TimelineChart";

export function Badge({ tone = "default", children, title }: { tone?: Tone; children: React.ReactNode; title?: string }) {
  return (
    <span className={toneClass(tone)} title={title}>
      {children}
    </span>
  );
}

export function StatusBadge({ status }: { status: TaskStatus }) {
  return (
    <span className={`${toneClass(STATUS_TONE[status])} status`} data-status={status}>
      {statusLabel(status)}
    </span>
  );
}

export function PriorityBadge({ priority, showNormal = false }: { priority: Priority; showNormal?: boolean }) {
  if (priority === "normal" && !showNormal) return null;
  return <Badge tone={PRIORITY_TONE[priority]}>{PRIORITY_TEXT[priority]}</Badge>;
}

const MATURITY_TONE: Record<Maturity, Tone> = { L0: "gray", L1: "gray", L2: "default", L3: "green" };

export function MaturityBadge({ maturity }: { maturity: Maturity }) {
  return <Badge tone={MATURITY_TONE[maturity]}>{MATURITY_TEXT[maturity]}</Badge>;
}

export function MarkerBadge({ kind }: { kind: string }) {
  return <Badge tone={MARKER_TONE[kind] ?? "gray"}>{MARKER_TEXT[kind] ?? kind}</Badge>;
}

export function DryBadge() {
  return <Badge tone="gray">dry run</Badge>;
}

export function ProgressBar({ k, n, big = false }: { k: number; n: number; big?: boolean }) {
  const pct = n > 0 ? Math.min(100, Math.round((k / n) * 100)) : 0;
  return (
    <div className={`progress${big ? " big" : ""}`} role="progressbar" aria-valuenow={k} aria-valuemax={n}>
      <span style={{ width: `${pct}%` }} />
    </div>
  );
}
